import { TablePaginationConfig } from 'antd';

export const initialPaginationState: TablePaginationConfig = {
    current: 1,
    pageSize: 10,
    position: ['bottomRight'],
    showSizeChanger: true,
};
